import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import { useGetDashboardOrdersQuery } from "../../../../newapi/reports/fulfillment/reportFulfillmentSlice";
import { useTranslation } from "react-i18next";
// import DonutChart from "../../../theme/charts/DonutChart";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import Heading from "../../../theme/text/Heading";
import Text from "../../../theme/text/Text";
import Subheading from "../../../theme/text/Subheading";

export const OrdersChart = (props) => {
    
    const { t, ready } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {data, isLoading, isFetching, isError,refetch} = useGetDashboardOrdersQuery(undefined, { skip: props.preview });
    
    // Function to handle retry
    const handleRetry = () => {
        refetch();
    };
    return (
        <Box
            sx={{

                padding:1.5,
                // paddingRight:3,
                height:1,
                // paddingBottom:3,
                background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[50] ,
                flex:1,
                borderRadius:4,
                gap:1,
                display:"flex",
                flexDirection:"column",
                boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                "@media screen and (max-width: 47.9375em)" : {
                },
                position:'relative',
                overflow:"hidden",

                "@media screen and (max-width: 768px)" : {
                    gridArea: "1 / 1 / 2 / 3",
                }
            }}
        >

            <Box
                sx={{
                    p:1.5,
                }}
            >
                <Subheading>{t("orders")}</Subheading>
                <Text light>{t("today")}</Text>
            </Box>

            <Box
                sx={{
                    display:"flex",
                    gap:1,
                    flex:2,
                }}
            >
                <Box
                    sx={{
                        background:colors.purple[100],
                        p:2,
                        flex:2,
                        display:'flex',
                        // flexDirection:"column",
                        justifyContent:"space-between",
                        borderRadius:2,
                        "@media screen and (max-width: 47.9375em)" : {
                            flexDirection:'column',
                            alignItems:"flex-start",
                        }
                    }}
                >

                    <Text>{t("to_process_now")}</Text>
                    <Typography variant="h1" fontWeight="1000" fontSize={32} fontFamily="Roboto, sans-serif"
                        sx={{
                            color: colors.purple[400],
                            textOverflow:"ellipsis",
                            whiteSpace:"nowrap",
                            overflow:"hidden",
                            // textAlign:align,
                        }}
                    >
                        {data?.now}
                    </Typography>
                </Box>

                <Box
                    sx={{
                        flex:1.5,
                        display:'flex',
                        flexDirection:"column",
                        gap:1,
                    }}
                >
                    <Box
                        sx={{
                            background:colors.green[100],
                            borderRadius:2,
                            flex:1,
                            p:2,
                            display:'flex',
                            // flexDirection:"column",
                            justifyContent:"space-between",
                            "@media screen and (max-width: 47.9375em)" : {
                                flexDirection:'column',
                                alignItems:"flex-start",
                            }

                        }}
                    >
                        <Text>{t("shipped")}</Text>
                        <Heading color={colors.green[400]}>
                            {data?.sent}
                        </Heading>

                    </Box>
                </Box>
            

            </Box>
            <Box
                sx={{
                    flex:1.5,
                    display:'flex',
                    gap:1,
                }}
            >
               
                <Box
                    sx={{
                        background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                        borderRadius:2,
                        flex:2,
                        p:2,
                        display:"flex",
                        justifyContent:"space-between",
                        "@media screen and (max-width: 47.9375em)" : {
                            flexDirection:'column',
                            alignItems:"flex-start",
                        }
                    }}
                >
                    <Text>{t("to_process_later")}</Text>
                    <Heading bold>{data?.later}</Heading>
                </Box>
                <Box
                    sx={{
                        flex:1.5,
                        display:'flex',
                        flexDirection:"column",
                        gap:1,
                    }}
                >
                    <Box
                        sx={{
                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                            borderRadius:2,
                            flex:1,
                            p:2,
                            display:"flex",
                            justifyContent:"space-between",
                            alignItems:'center',
                            // flexWrap:"wrap",

                            "@media screen and (max-width: 47.9375em)" : {
                                flexDirection:'column',
                                alignItems:"flex-start",
                            }
                        }}
                    >
                        <Text>{t("to_process_total_todo")}</Text>
                        <Heading className={"allow-overflow"} bold>{data?.totalTodo}</Heading>

                    </Box>
                    <Box
                        sx={{
                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                            borderRadius:2,
                            flex:1,
                            p:2,
                            display:"flex",
                            justifyContent:"space-between",

                            "@media screen and (max-width: 47.9375em)" : {
                                flexDirection:'column',
                                alignItems:"flex-start",
                            }
                        }}
                    >

                        <Text>{t("total")}</Text>
                        <Heading>
                            {data?.total}
                        </Heading>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}